import { inject, Injectable } from '@angular/core';
import { ApiDataAccess, Dictionary, ApiResourceLocation } from '@softline/core';
import { SOFTLINE_API_GARAGE_MECHANICS } from '../garage.api';
import { Mechanic } from '../models/mechanic';

@Injectable()
export class MechanicRepository {
  readonly #dataAccess = inject(ApiDataAccess);

  private createLocation(
    path: string,
    pathParams?: Dictionary<unknown>
  ): ApiResourceLocation {
    return pathParams ? { path, pathParams } : { path };
  }

  retrieve(): Promise<Mechanic[]> {
    return this.#dataAccess.get(this.createLocation(SOFTLINE_API_GARAGE_MECHANICS));
  }
}
